module.exports = __webpack_public_path__ + "static/media/ups_1.7d6c8871.png";